// extracted by mini-css-extract-plugin
export var searchHeader = "_2u-0";
export var searchHeaderDark = "_2u-1";